import { Stack, styled } from "@mui/material";

export const BookLoanWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        padding: "var(--basic-padding)",
        backgroundColor: "var(--light-color)",
        borderRadius: "16px",
        overflow: "hidden",
        "& .tab-button-stack": {
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "calc(var(--flex-gap) / 4)",
            justifyContent: "space-between",
            overflow: "hidden",
            background: "var(--diluted-primary-color)",
            padding: "calc(var(--basic-padding)/2)",
            borderRadius: "8px",
            "& .tab-button": {
                borderRadius: "8px",
                padding: "calc(var(--basic-padding)/4)",
                flex: 1,
                display: "flex",
                justifyContent: "center",
                cursor: "pointer",
            }
        },
        "& .loan-summary-table-box": {
            "& .MuiTableContainer-root": {
                border: "2px solid var(--dark-color)",
                borderRadius: "12px",
                "& .MuiTableBody-root": {
                    "& .MuiTableCell-root": {
                        border: "1px solid var(--semi-dark-color)",
                    },
                    "& .MuiTableCell-root:first-of-type": {
                        width: "25%",
                    }
                }
            },
        },
        "& .collateral-table-box": {
            marginBottom: "calc(var(--basic-margin))",
        },
        "& .guarantor-table-box": {
            marginBottom: "calc(var(--basic-margin))",
        },
        "& .loan-charges-table-box, & .loan-repayment-schedule-box, & .loan-repayment-details-table-box": {
            "& .MuiTableContainer-root": {
                border: "2px solid var(--dark-color)",
                borderRadius: "12px",
                "& .MuiTableHead-root": {
                    "& .MuiTableCell-root": {
                        border: "1px solid var(--semi-dark-color)",
                    },
                },
                "& .MuiTableBody-root": {
                    "& .MuiTableCell-root": {
                        border: "1px solid var(--semi-dark-color)",
                    },
                    "& .MuiTableCell-root:first-of-type": {
                        width: "25%",
                    }
                }
            },
        },
        "& .dropdown-modal": {
            position: "absolute",
            right: "calc(var(--basic-padding) * 1.5)",
            backgroundColor: "var(--light-color)",
            boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
            zIndex: 1,
            borderRadius: "8px",
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: "calc(var(--basic-margin)/4)",
            overflow: "hidden",
            maxWidth: "250px",
            "& .MuiListItem-root": {
                padding: 0,
                "& .MuiListItemText-root": {
                    fontSize: "16px",
                },
                "&:hover": {
                    backgroundColor: "var(--diluted-primary-color)",
                }
            },
        },
    }
});